import { ipMatchWord } from "../../../../constants";

export type MoneticsFormData = {
    mark: string;
    designation: string;
    reference: string;
    port: any;
    speed: string | number;
    ipAddress: string;
    merchantCode: string;
    url: string;
    paymentType: string;
    paymentMethod: any;
    timeout: string;
    typeConfig: any;
    typeTerminal: any;
    webhook: string;
    mode: string;
    idIntegrator: string;
    currency: string;
    selectedIdAdyen: { label: string; value: string };
    keyValue: string;
    serialNumber: any;
    communication: string;
    isNameExist: boolean;
    isIdExist: boolean;
    ipExist: boolean;
    shopIds: any;
    selectInputPM: boolean;
    inputTimeout: boolean;
    notStartWithSpaceRegExp: RegExp;
    numberMatchWord: RegExp;
};

/**
 * Returns a map of field names to error booleans.
 * Used to set individual field error states.
 */
export function getMoneticsValidationErrors(data: MoneticsFormData): Record<string, boolean> {
    const errors: Record<string, boolean> = {};
    errors.selectMark = data.mark === "";
    errors.inputIp = !data.ipAddress.match(ipMatchWord);
    errors.inputDesignation = data.designation === "";
    errors.speedSelectInput = data.speed === "";
    errors.portSelectInput = data.port === "";
    errors.inputPortAdyen = data.port === "";
    errors.inputPort = data.port === "";
    errors.selectInput = data.paymentType === "";
    errors.inputCode = data.merchantCode === "";
    errors.inputUrl = data.url === "";
    errors.inputWebhook = data.webhook === "";
    errors.inputMode = data.mode === "";
    errors.selectInputPM = Object.keys(data.paymentMethod).length === 0;
    errors.inputTimeout = data.timeout === "";
    errors.inputTerminalType = data.typeTerminal === "";
    errors.inputSetupType = data.typeConfig === "";
    errors.inputIdIntegrator = data.idIntegrator === "";
    errors.inputCurrency = data.currency === "";
    errors.inputID = data.selectedIdAdyen.label === "";
    errors.inputKey = data.keyValue === "";
    errors.inputSerialNumber = data.serialNumber === "";
    return errors;
}

/**
 * Returns whether the monetics form is valid for the given mark type.
 */
export function isMoneticsFormValid(data: MoneticsFormData): boolean {
    const {
        mark,
        designation,
        reference,
        port,
        speed,
        ipAddress,
        merchantCode,
        url,
        paymentType,
        paymentMethod,
        timeout,
        typeConfig,
        typeTerminal,
        webhook,
        mode,
        idIntegrator,
        currency,
        selectedIdAdyen,
        keyValue,
        serialNumber,
        communication,
        isNameExist,
        isIdExist,
        ipExist,
        shopIds,
        selectInputPM,
        inputTimeout,
        notStartWithSpaceRegExp,
        numberMatchWord,
    } = data;

    const nameExistBlock = (minShopLength: number) =>
        !(
            (isNameExist &&
                (shopIds === undefined || shopIds.length === 0)) ||
            (isNameExist && shopIds.length >= minShopLength)
        );

    const designationValid =
        designation.length !== 0 &&
        designation?.trim() !== "" &&
        designation.match(notStartWithSpaceRegExp);

    return (
        (mark === "Valina" &&
            designationValid &&
            reference !== "" &&
            port !== "" &&
            speed !== "" &&
            paymentMethod !== "" &&
            timeout !== "" &&
            nameExistBlock(1) &&
            selectInputPM === false &&
            inputTimeout === false) ||
        (mark === "Nepting" &&
            typeConfig !== "" &&
            typeTerminal !== "" &&
            designationValid &&
            reference !== "" &&
            ipAddress !== "" &&
            port !== "" &&
            merchantCode !== "" &&
            url !== "" &&
            paymentType !== "" &&
            Number(port) &&
            !!ipAddress.match(ipMatchWord) &&
            ipExist === false &&
            nameExistBlock(1) &&
            true) ||
        (mark === "Adyen" &&
            !isIdExist &&
            designationValid &&
            port !== "" &&
            mode !== "" &&
            webhook !== "" &&
            ipAddress !== "" &&
            selectedIdAdyen.value !== "" &&
            !!ipAddress.match(ipMatchWord) &&
            !!port.match(numberMatchWord) &&
            !!webhook.match(numberMatchWord) &&
            ipExist === false &&
            nameExistBlock(1) &&
            true) ||
        (mark === "Valina swiss" &&
            designationValid &&
            nameExistBlock(1) &&
            idIntegrator !== "" &&
            currency !== "") ||
        mark === "MS Solution Tunisie" ||
        (mark === "Yavin" &&
            port !== "" &&
            designationValid &&
            nameExistBlock(1) &&
            /^[a-zA-Z0-9]*$/.test(designation) &&
            communication === "Local" &&
            ipAddress !== "" &&
            !!ipAddress.match(ipMatchWord)) ||
        (communication === "Cloud" &&
            keyValue !== "" &&
            serialNumber !== "")
    );
}
